import { render, staticRenderFns } from "./USplit.vue?vue&type=template&id=6d24f8be&scoped=true&"
import script from "./USplit.vue?vue&type=script&lang=js&"
export * from "./USplit.vue?vue&type=script&lang=js&"
import style0 from "./USplit.vue?vue&type=style&index=0&id=6d24f8be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d24f8be",
  null
  
)

export default component.exports